<template>
  <div class="event-stats-button" data-t="event-stats-button">
    <StButton :size :type icon="graph-solid" :to-external="statsUrl" />
  </div>
</template>

<script setup lang="ts">
const {
  eventId,
  type = 'ghost',
  size = 'xs',
} = defineProps<{
  eventId: number
  type?: 'ghost' | 'text-tertiary'
  size?: 'm' | 'xs'
}>()

const { locale } = useI18n()
const { baseURL } = useRuntimeConfig().public.api

const statsUrl = computed(() => {
  const urlParams = new URLSearchParams()
  urlParams.append('lang', locale.value)
  urlParams.append('eventId', String(eventId))

  return `${baseURL}/stats?${urlParams.toString()}`
})
</script>

<style scoped>
.event-stats-button {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
